export interface Work {
  id: string;
  title: string;
  cover: string;
  images: string[];
  authorId: string;
  categoryId: string;
  style: '创意' | '人文' | '自然' | '极简';
  location: '室内' | '户外';
  uploadTime: string;
  likes: number;
  favorites: number;
  tags: string[];
  camera: string;
  shootLocation: string;
  description: string;
}

export const works: Work[] = [
  {
    id: 'w01',
    title: '逆光少女',
    cover: 'https://readdy.ai/api/search-image?query=backlit%20portrait%20of%20young%20woman%20with%20flowing%20hair%2C%20warm%20orange%20sunset%20glow%2C%20dreamy%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20portrait%20photography&width=900&height=1100&seq=work-w01&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=backlit%20portrait%20of%20young%20woman%20with%20flowing%20hair%2C%20warm%20orange%20sunset%20glow%2C%20dreamy%20atmosphere%2C%20shallow%20depth%20of%20field%2C%20editorial%20portrait%20photography&width=1400&height=1700&seq=work-w01-a&orientation=portrait',
    ],
    authorId: 'u01',
    categoryId: 'portrait',
    style: '人文',
    location: '户外',
    uploadTime: '2026-09-28',
    likes: 1284,
    favorites: 356,
    tags: ['逆光', '人像', '日落'],
    camera: 'Sony A7M4 / 85mm f1.4',
    shootLocation: '上海 滨江步道',
    description: '傍晚六点半的江边，光线刚好从她的发丝间穿过，按下快门的瞬间觉得一切都值了。',
  },
  {
    id: 'w02',
    title: '棚拍·橘调人像',
    cover: 'https://readdy.ai/api/search-image?query=studio%20portrait%20photography%20with%20warm%20orange%20gel%20lighting%2C%20fashion%20editorial%20pose%2C%20clean%20gray%20background%2C%20high%20fashion%20style&width=900&height=1100&seq=work-w02&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=studio%20portrait%20photography%20with%20warm%20orange%20gel%20lighting%2C%20fashion%20editorial%20pose%2C%20clean%20gray%20background%2C%20high%20fashion%20style&width=1400&height=1700&seq=work-w02-a&orientation=portrait',
    ],
    authorId: 'u01',
    categoryId: 'portrait',
    style: '创意',
    location: '室内',
    uploadTime: '2026-09-20',
    likes: 982,
    favorites: 201,
    tags: ['棚拍', '色胶', '时尚'],
    camera: 'Canon R5 / 50mm f1.2',
    shootLocation: '上海 影棚',
    description: '用橘色色片打出戏剧性的光影层次，想要表达一种热烈又克制的情绪。',
  },
  {
    id: 'w03',
    title: '云海日出',
    cover: 'https://readdy.ai/api/search-image?query=sea%20of%20clouds%20sunrise%20over%20mountain%20peaks%2C%20warm%20golden%20orange%20sky%2C%20layered%20mountains%2C%20epic%20wide%20landscape%20photography&width=900&height=1200&seq=work-w03&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=sea%20of%20clouds%20sunrise%20over%20mountain%20peaks%2C%20warm%20golden%20orange%20sky%2C%20layered%20mountains%2C%20epic%20wide%20landscape%20photography&width=1600&height=2000&seq=work-w03-a&orientation=portrait',
    ],
    authorId: 'u02',
    categoryId: 'landscape',
    style: '自然',
    location: '户外',
    uploadTime: '2026-09-25',
    likes: 2156,
    favorites: 643,
    tags: ['日出', '云海', '山景'],
    camera: 'Nikon Z8 / 16-35mm',
    shootLocation: '四川 四姑娘山',
    description: '凌晨四点爬上观景台，等了两个小时，云海翻腾的那一刻什么都值了。',
  },
  {
    id: 'w04',
    title: '秋日枫林',
    cover: 'https://readdy.ai/api/search-image?query=autumn%20maple%20forest%20with%20warm%20orange%20red%20foliage%2C%20soft%20sunlight%20through%20leaves%2C%20dreamy%20landscape%20photography&width=900&height=1100&seq=work-w04&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=autumn%20maple%20forest%20with%20warm%20orange%20red%20foliage%2C%20soft%20sunlight%20through%20leaves%2C%20dreamy%20landscape%20photography&width=1400&height=1700&seq=work-w04-a&orientation=portrait',
    ],
    authorId: 'u02',
    categoryId: 'landscape',
    style: '自然',
    location: '户外',
    uploadTime: '2026-09-15',
    likes: 1532,
    favorites: 412,
    tags: ['秋天', '枫叶', '光影'],
    camera: 'Nikon Z8 / 24-70mm',
    shootLocation: '四川 光雾山',
    description: '阳光穿过枫叶洒下斑驳光点，整片山林都是暖橘色的。',
  },
  {
    id: 'w05',
    title: '露珠上的世界',
    cover: 'https://readdy.ai/api/search-image?query=macro%20photography%20of%20dew%20drop%20reflecting%20tiny%20world%2C%20warm%20orange%20bokeh%20background%2C%20extreme%20close%20up%20detail&width=900&height=1100&seq=work-w05&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=macro%20photography%20of%20dew%20drop%20reflecting%20tiny%20world%2C%20warm%20orange%20bokeh%20background%2C%20extreme%20close%20up%20detail&width=1400&height=1700&seq=work-w05-a&orientation=portrait',
    ],
    authorId: 'u03',
    categoryId: 'macro',
    style: '自然',
    location: '户外',
    uploadTime: '2026-09-22',
    likes: 876,
    favorites: 298,
    tags: ['微距', '露珠', '清晨'],
    camera: 'Canon R6 / 100mm Macro',
    shootLocation: '杭州 植物园',
    description: '清晨六点草叶上的露珠倒映着整个世界，这就是微观摄影的魅力。',
  },
  {
    id: 'w06',
    title: '甲虫的盔甲',
    cover: 'https://readdy.ai/api/search-image?query=macro%20photography%20of%20beetle%20with%20metallic%20shell%20texture%2C%20warm%20orange%20lighting%2C%20extreme%20detail%20close%20up%2C%20clean%20dark%20background&width=900&height=1100&seq=work-w06&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=macro%20photography%20of%20beetle%20with%20metallic%20shell%20texture%2C%20warm%20orange%20lighting%2C%20extreme%20detail%20close%20up%2C%20clean%20dark%20background&width=1400&height=1700&seq=work-w06-a&orientation=portrait',
    ],
    authorId: 'u03',
    categoryId: 'macro',
    style: '极简',
    location: '室内',
    uploadTime: '2026-09-10',
    likes: 654,
    favorites: 187,
    tags: ['昆虫', '质感', '微距'],
    camera: 'Canon R6 / 100mm Macro',
    shootLocation: '杭州 工作室',
    description: '用环形闪光灯打出甲虫壳体的金属光泽，像一件精密的机械。',
  },
  {
    id: 'w07',
    title: '双重曝光·梦境',
    cover: 'https://readdy.ai/api/search-image?query=surreal%20double%20exposure%20portrait%20with%20forest%20silhouette%2C%20warm%20orange%20and%20gray%20tones%2C%20dreamlike%20artistic%20composition&width=900&height=1100&seq=work-w07&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=surreal%20double%20exposure%20portrait%20with%20forest%20silhouette%2C%20warm%20orange%20and%20gray%20tones%2C%20dreamlike%20artistic%20composition&width=1400&height=1700&seq=work-w07-a&orientation=portrait',
    ],
    authorId: 'u04',
    categoryId: 'creative',
    style: '创意',
    location: '户外',
    uploadTime: '2026-09-27',
    likes: 1890,
    favorites: 521,
    tags: ['双重曝光', '超现实', '创意'],
    camera: 'Fujifilm X-T5 / 35mm',
    shootLocation: '北京 工作室合成',
    description: '把人像和森林叠在一起，想表达一种"身在城市，心在山野"的状态。',
  },
  {
    id: 'w08',
    title: '破碎镜面自拍',
    cover: 'https://readdy.ai/api/search-image?query=creative%20self%20portrait%20through%20broken%20mirror%20fragments%2C%20warm%20orange%20tone%2C%20abstract%20artistic%20photography&width=900&height=1100&seq=work-w08&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=creative%20self%20portrait%20through%20broken%20mirror%20fragments%2C%20warm%20orange%20tone%2C%20abstract%20artistic%20photography&width=1400&height=1700&seq=work-w08-a&orientation=portrait',
    ],
    authorId: 'u04',
    categoryId: 'creative',
    style: '创意',
    location: '室内',
    uploadTime: '2026-09-18',
    likes: 1123,
    favorites: 334,
    tags: ['镜面', '抽象', '自拍'],
    camera: 'Fujifilm X-T5 / 23mm',
    shootLocation: '北京 工作室',
    description: '碎镜片折射出的多重影像，像是在探索自我的不同面。',
  },
  {
    id: 'w09',
    title: '巷口的老王',
    cover: 'https://readdy.ai/api/search-image?query=documentary%20street%20portrait%20of%20elderly%20man%20in%20alley%2C%20warm%20evening%20light%2C%20candid%20expression%2C%20editorial%20documentary%20photography&width=900&height=1100&seq=work-w09&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=documentary%20street%20portrait%20of%20elderly%20man%20in%20alley%2C%20warm%20evening%20light%2C%20candid%20expression%2C%20editorial%20documentary%20photography&width=1400&height=1700&seq=work-w09-a&orientation=portrait',
    ],
    authorId: 'u05',
    categoryId: 'street',
    style: '人文',
    location: '户外',
    uploadTime: '2026-09-24',
    likes: 1345,
    favorites: 402,
    tags: ['街拍', '人文', '纪实'],
    camera: 'Leica Q2',
    shootLocation: '广州 老城区',
    description: '每天这个时间他都坐在巷口下棋，光线斜斜打在脸上，很有故事感。',
  },
  {
    id: 'w10',
    title: '菜市场烟火气',
    cover: 'https://readdy.ai/api/search-image?query=documentary%20street%20photography%20of%20busy%20local%20market%2C%20warm%20orange%20tone%2C%20candid%20everyday%20life%2C%20editorial%20style&width=900&height=1100&seq=work-w10&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=documentary%20street%20photography%20of%20busy%20local%20market%2C%20warm%20orange%20tone%2C%20candid%20everyday%20life%2C%20editorial%20style&width=1400&height=1700&seq=work-w10-a&orientation=portrait',
    ],
    authorId: 'u05',
    categoryId: 'street',
    style: '人文',
    location: '户外',
    uploadTime: '2026-09-12',
    likes: 987,
    favorites: 256,
    tags: ['市井', '生活', '纪实'],
    camera: 'Leica Q2',
    shootLocation: '广州 菜市场',
    description: '清晨的菜市场最有生活气息，讨价还价的声音都是温暖的。',
  },
  {
    id: 'w11',
    title: '霓虹十字路口',
    cover: 'https://readdy.ai/api/search-image?query=night%20city%20crossroad%20with%20warm%20orange%20neon%20signs%2C%20long%20exposure%20car%20light%20trails%2C%20cinematic%20urban%20night%20photography&width=900&height=1200&seq=work-w11&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=night%20city%20crossroad%20with%20warm%20orange%20neon%20signs%2C%20long%20exposure%20car%20light%20trails%2C%20cinematic%20urban%20night%20photography&width=1500&height=2000&seq=work-w11-a&orientation=portrait',
    ],
    authorId: 'u06',
    categoryId: 'night',
    style: '极简',
    location: '户外',
    uploadTime: '2026-09-26',
    likes: 1678,
    favorites: 489,
    tags: ['夜景', '光轨', '城市'],
    camera: 'Sony A7RV / 24mm',
    shootLocation: '重庆 解放碑',
    description: '三脚架架了半小时，等一辆辆车流拖出橘色的光轨。',
  },
  {
    id: 'w12',
    title: '星空下的帐篷',
    cover: 'https://readdy.ai/api/search-image?query=camping%20tent%20under%20starry%20night%20sky%2C%20warm%20orange%20tent%20light%20glow%2C%20milky%20way%20visible%2C%20cinematic%20night%20landscape&width=900&height=1100&seq=work-w12&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=camping%20tent%20under%20starry%20night%20sky%2C%20warm%20orange%20tent%20light%20glow%2C%20milky%20way%20visible%2C%20cinematic%20night%20landscape&width=1400&height=1700&seq=work-w12-a&orientation=portrait',
    ],
    authorId: 'u06',
    categoryId: 'night',
    style: '自然',
    location: '户外',
    uploadTime: '2026-09-08',
    likes: 1456,
    favorites: 378,
    tags: ['星空', '露营', '长曝光'],
    camera: 'Sony A7RV / 14mm',
    shootLocation: '甘肃 戈壁',
    description: '帐篷里透出的暖光和头顶的银河形成了很棒的对比。',
  },
  {
    id: 'w13',
    title: '侧脸剪影',
    cover: 'https://readdy.ai/api/search-image?query=silhouette%20profile%20portrait%20against%20warm%20orange%20sunset%20window%20light%2C%20minimal%20composition%2C%20editorial%20photography&width=900&height=1100&seq=work-w13&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=silhouette%20profile%20portrait%20against%20warm%20orange%20sunset%20window%20light%2C%20minimal%20composition%2C%20editorial%20photography&width=1400&height=1700&seq=work-w13-a&orientation=portrait',
    ],
    authorId: 'u01',
    categoryId: 'portrait',
    style: '极简',
    location: '室内',
    uploadTime: '2026-09-05',
    likes: 743,
    favorites: 210,
    tags: ['剪影', '窗光', '极简'],
    camera: 'Sony A7M4 / 50mm',
    shootLocation: '上海 公寓',
    description: '午后窗边的光线刚好勾勒出她的侧脸轮廓。',
  },
  {
    id: 'w14',
    title: '梯田晨雾',
    cover: 'https://readdy.ai/api/search-image?query=terraced%20rice%20fields%20with%20morning%20fog%2C%20warm%20golden%20orange%20light%2C%20layered%20curves%2C%20epic%20landscape%20photography&width=900&height=1100&seq=work-w14&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=terraced%20rice%20fields%20with%20morning%20fog%2C%20warm%20golden%20orange%20light%2C%20layered%20curves%2C%20epic%20landscape%20photography&width=1400&height=1700&seq=work-w14-a&orientation=portrait',
    ],
    authorId: 'u02',
    categoryId: 'landscape',
    style: '自然',
    location: '户外',
    uploadTime: '2026-08-30',
    likes: 1234,
    favorites: 345,
    tags: ['梯田', '晨雾', '日出'],
    camera: 'Nikon Z8 / 70-200mm',
    shootLocation: '云南 元阳',
    description: '无人机升起的瞬间，晨雾正好漫过梯田的曲线。',
  },
  {
    id: 'w15',
    title: '雪花的结构',
    cover: 'https://readdy.ai/api/search-image?query=macro%20photography%20of%20snowflake%20crystal%20structure%2C%20warm%20orange%20backlight%2C%20extreme%20detail%2C%20clean%20dark%20background&width=900&height=1100&seq=work-w15&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=macro%20photography%20of%20snowflake%20crystal%20structure%2C%20warm%20orange%20backlight%2C%20extreme%20detail%2C%20clean%20dark%20background&width=1400&height=1700&seq=work-w15-a&orientation=portrait',
    ],
    authorId: 'u03',
    categoryId: 'macro',
    style: '极简',
    location: '户外',
    uploadTime: '2026-08-20',
    likes: 892,
    favorites: 267,
    tags: ['雪花', '结晶', '微距'],
    camera: 'Canon R6 / 100mm Macro',
    shootLocation: '哈尔滨',
    description: '零下二十度蹲在雪地里拍了一个小时，终于等到一片完整的雪花。',
  },
  {
    id: 'w16',
    title: '人形气球装置',
    cover: 'https://readdy.ai/api/search-image?query=creative%20conceptual%20photography%20with%20orange%20balloon%20installation%20and%20human%20figure%2C%20minimal%20studio%20background%2C%20artistic%20composition&width=900&height=1100&seq=work-w16&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=creative%20conceptual%20photography%20with%20orange%20balloon%20installation%20and%20human%20figure%2C%20minimal%20studio%20background%2C%20artistic%20composition&width=1400&height=1700&seq=work-w16-a&orientation=portrait',
    ],
    authorId: 'u04',
    categoryId: 'creative',
    style: '创意',
    location: '室内',
    uploadTime: '2026-08-15',
    likes: 1567,
    favorites: 445,
    tags: ['装置', '概念', '创意'],
    camera: 'Fujifilm X-T5 / 35mm',
    shootLocation: '北京 工作室',
    description: '用一百个橘色气球搭了一个装置，想表达"轻盈的重量"这个概念。',
  },
  {
    id: 'w17',
    title: '雨中骑行人',
    cover: 'https://readdy.ai/api/search-image?query=documentary%20street%20photography%20of%20cyclist%20in%20rain%20with%20warm%20streetlight%20reflections%2C%20candid%20urban%20scene%2C%20editorial%20style&width=900&height=1100&seq=work-w17&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=documentary%20street%20photography%20of%20cyclist%20in%20rain%20with%20warm%20streetlight%20reflections%2C%20candid%20urban%20scene%2C%20editorial%20style&width=1400&height=1700&seq=work-w17-a&orientation=portrait',
    ],
    authorId: 'u05',
    categoryId: 'street',
    style: '人文',
    location: '户外',
    uploadTime: '2026-08-10',
    likes: 1098,
    favorites: 289,
    tags: ['雨天', '街拍', '骑行'],
    camera: 'Leica Q2',
    shootLocation: '广州 街头',
    description: '路灯在湿漉漉的地面反射出暖橘色的光斑，骑行人正好经过。',
  },
  {
    id: 'w18',
    title: '摩天轮灯光秀',
    cover: 'https://readdy.ai/api/search-image?query=ferris%20wheel%20illuminated%20with%20warm%20orange%20lights%20at%20night%2C%20long%20exposure%2C%20cinematic%20amusement%20park%20photography&width=900&height=1200&seq=work-w18&orientation=portrait',
    images: [
      'https://readdy.ai/api/search-image?query=ferris%20wheel%20illuminated%20with%20warm%20orange%20lights%20at%20night%2C%20long%20exposure%2C%20cinematic%20amusement%20park%20photography&width=1500&height=2000&seq=work-w18-a&orientation=portrait',
    ],
    authorId: 'u06',
    categoryId: 'night',
    style: '创意',
    location: '户外',
    uploadTime: '2026-08-05',
    likes: 1789,
    favorites: 512,
    tags: ['摩天轮', '长曝光', '夜景'],
    camera: 'Sony A7RV / 24-70mm',
    shootLocation: '重庆 游乐园',
    description: '长曝光拍出摩天轮转动的光轨，像一朵绽放的橘色花。',
  },
];

export const getWorkById = (id: string) => works.find((w) => w.id === id);
export const getWorksByCategory = (categoryId: string) =>
  works.filter((w) => w.categoryId === categoryId);
export const getWorksByAuthor = (authorId: string) =>
  works.filter((w) => w.authorId === authorId);
export const getRelatedWorks = (work: Work, limit = 4) =>
  works
    .filter((w) => w.id !== work.id && w.tags.some((t) => work.tags.includes(t)))
    .slice(0, limit);